// Mock Contributors Data
// Extracted from About.tsx

export interface Contributor {
  name: string;
  contribution: string;
  category: string;
  description: string;
  icon: string;
  color: string;
}

export const mockContributors: Contributor[] = [
  {
    name: "Aunt Maggie",
    contribution: "Original inspiration for Food Tracker correlation analysis",
    category: "Feature Ideas",
    description: "Hospital blood bank technician with 30+ years experience and Type 2 diabetes. Her need for statistical food-glucose correlation inspired the core analytics engine.",
    icon: "❤️",
    color: 'bg-pink-100 text-pink-700 border-pink-200'
  },
  {
    name: "Dr. Sarah Chen",
    contribution: "Medical validation and clinical insights",
    category: "Medical Expertise",
    description: "Board-certified endocrinologist providing medical oversight and clinical validation for diabetes management features.",
    icon: "👩‍⚕️",
    color: 'bg-blue-100 text-blue-700 border-blue-200'
  },
  {
    name: "Coach Mike Rodriguez",
    contribution: "Fitness and nutrition guidance",
    category: "Wellness Coaching",
    description: "Certified personal trainer and registered dietitian contributing expertise in fitness tracking and nutrition planning.",
    icon: "💪",
    color: 'bg-green-100 text-green-700 border-green-200'
  },
  {
    name: "Grandmother Betty",
    contribution: "Traditional recipe preservation",
    category: "Community Recipes",
    description: "Family recipe keeper sharing generations of cooking wisdom and traditional meal preparation methods.",
    icon: "👵",
    color: 'bg-yellow-100 text-yellow-700 border-yellow-200'
  },
  {
    name: "Data Detective Dan",
    contribution: "AI analysis and data insights",
    category: "Technical Innovation",
    description: "Data scientist specializing in health analytics and machine learning for personalized health recommendations.",
    icon: "🧠",
    color: 'bg-purple-100 text-purple-700 border-purple-200'
  }
]; 